import React from "react";
import { Link } from "react-router-dom";
import { IoMdArrowBack } from "react-icons/io";

const RequestPopup = ({ request, popupRef, onClose, encryptId, children }) => {
  if (!request) return null;

  return (
    <div className="whole-hide" onClick={onClose}>
      <div
        className="hided-details"
        ref={popupRef}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="popup-header-row">
          <div className="popup-left">
            <span className="popup-back-icon" onClick={onClose}>
              <IoMdArrowBack />
            </span>

            <h3>Request ID: {request.id}</h3>
          </div>

          <div className="popup-header-actions">
            <Link
              to={`/inbox/${encryptId(request.id)}?section=tracking`}
              className="popup-view-btn"
            >
              Tracking
            </Link>

            <Link
              to={
                request.supportNeeded.includes("Courier")
                  ? `/courier-details/${encryptId(request.id)}`
                  : `/full-details/${encryptId(request.id)}`
              }
              className="popup-view-btn"
            >
              View full details
            </Link>
          </div>
        </div>

        {children}
      </div>
    </div>
  );
};

export default RequestPopup;
